import * as yup from 'yup';
import docs from './attachments/specific';
import {
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDadosSensiveis,
  consentimentoDescontoFolha,
  cpfResponsavelLegal,
  nomeDoTutor,
  parentesco,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const matTempSchema = () => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  return yup.object({
    ...parentesco,
    ...cpfResponsavelLegal,
    ...nomeDoTutor,
    ...adiantamentoQuinzenal,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...dadosSensiveis,
    ...consentimentoDescontoFolha,
    ...declaracaoVeracidade,
    ...consentimentoAcertoFinanceiro,
    ...docs.MATTemporariaDocs.rules,
    ...aceiteInss,
  });
};

export const matTempInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDadosSensiveis: false,
  consentimentoDescontoFolha: false,
  declaracaoVeracidade: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  ...docs.MATTemporariaDocs.initialValues,
};

export const matTempDocs = {
  ...docs.MATTemporariaDocs.docs,
};
